// Centralized fetch interceptor that auto-injects API key auth headers
// for users who logged in via API Key (bypassing Entra ID)
import { getBypassSession } from './auth';

const originalFetch = window.fetch.bind(window);

// True for any request whose PATH targets the API, whether the caller used a
// relative ('/api/...') or absolute ('http://localhost:7073/api/...') URL.
// Matching on startsWith('/api/') alone missed absolute URLs, so bypass-session
// requests to the local Functions host went out without the x-api-key header (backlog L5).
function isApiRequest(url: string): boolean {
  try {
    return new URL(url, window.location.origin).pathname.startsWith('/api/');
  } catch {
    return url.startsWith('/api/');
  }
}

window.fetch = function (input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const url = typeof input === 'string' ? input : input instanceof URL ? input.toString() : input.url;

  // Only intercept API calls
  if (isApiRequest(url)) {
    const session = getBypassSession();
    if (session?.apiKey) {
      const headers = new Headers(init?.headers);
      if (!headers.has('x-api-key')) {
        headers.set('x-api-key', session.apiKey);
      }
      return originalFetch(input, { ...init, headers });
    }
  }

  return originalFetch(input, init);
} as typeof fetch;
